import "./About.scss";
import imgAbout from "../../Assets/about.webp";
import imgAbout2 from "../../Assets/about 2.webp";
import aboutImages from "../../Assets/About";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as Checkin } from "../../Assets/svg/checkin.svg";
const About = () => {
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };
  const pointData = [
    "Kawasan kota mandiri",
    "New Mall Summarecon",
    "Dilewati Future MRT Phase 3",
    "1 Menit Pintu Toll",
    "15 Menit ke Gading Serpong",
    "30 Menit ke Jakarta",
  ];

  return (
    <section id="about" className="section-about">
      <div className="container">
        <div className="container-images">
          <img
            src={imgAbout}
            alt="about summarecon tangerang"
            className="image-1"
          />
          <img
            src={imgAbout2}
            alt="about summarecon tangerang"
            className="image-2"
          />
        </div>
        <div className="container-description">
          <h3 className="title">Discover the Serenity of Lakeside Living</h3>
          <p className="description">
            Dikelilingi oleh enam danau yang indah, Summarecon Tangerang hadir
            sebagai kawasan hunian seluas 109 hektar yang menawarkan kenyamanan
            dan keasrian. <br /> Proyek dari Summarecon Group ini berlokasi
            strategis dekat akses Tol Bitung dan Serpong, dirancang sebagai
            walkable township dengan fasilitas lengkap, mulai dari clubhouse
            mewah hingga pusat kuliner dan hiburan, serta akses transportasi
            yang mudah, termasuk rencana lintasan MRT.
          </p>
          {pointData.map((point) => (
            <div className="points">
              <Checkin
                width={21}
                height={21}
                fill={"#1F4166"}
                className="icon"
              ></Checkin>
              <span>{point}</span>
            </div>
          ))}
          <button onClick={waOpen} className="btn-about">
            Learn More
          </button>
        </div>
      </div>
      <div className="slider" id="fasilitas">
        <Slider {...settings}>
          {aboutImages.map((image) => (
            <div className="slide">
              <img src={image.src} alt="about Summarecon Tangerang" />
              <div className="description">
                <p>{image.text}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default About;
